import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class CreateMultiGiftCardSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '1f4b4c8ce5b44c1d8066a9ce5d5c682a';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.CreateMultiGiftCard;

  private constructor(
    public readonly templateId: string,
    public readonly variationId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return CreateMultiGiftCardSideEffect.TYPE_ID;
  }

  static create(args: {
    templateId: string,
    variationId: string,
  }): CreateMultiGiftCardSideEffect {
    return new CreateMultiGiftCardSideEffect(
        args.templateId,
        args.variationId,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): CreateMultiGiftCardSideEffect {
    return new CreateMultiGiftCardSideEffect(
        MapUtils.getString(map, 'templateId'),
        MapUtils.getString(map, 'variationId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
      'templateId': this.templateId,
      'variationId': this.variationId,
    };
  }

  clone(): this {
    return new CreateMultiGiftCardSideEffect(
        this.templateId,
        this.variationId,
    ) as this;
  }

  isSame(other: CreateMultiGiftCardSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType &&
      other.templateId === this.templateId &&
      other.variationId === this.variationId;
  }

  toLegacyOrderHook(): LegacyOrderHook | null {
    return null;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CreateMultiGiftCardSideEffect;
  }

  static assertType(order: DataModel): order is CreateMultiGiftCardSideEffect {
    return order instanceof CreateMultiGiftCardSideEffect;
  }
}

export class CreateMultiGiftCardSideEffectBuilder extends DataModelBuilder<CreateMultiGiftCardSideEffect> {
  build(context: SerializationContext, map: SerializedData): CreateMultiGiftCardSideEffect {
    return CreateMultiGiftCardSideEffect.fromMap(context, map);
  }
}
